import { motion } from 'framer-motion'
import personHero from '../../../assets/images/doctor-legal/ilustracoes/person-hero.png'

const ctaVariant = {
  hidden: { opacity: 0, y: 15, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
}

const itemVariant = {
  hidden: { opacity: 0, y: 15, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
}

function CTAButtons({ className = '' }) {
  return (
    <div className={`flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto ${className}`}>
      <a href="#planos" className="btn-primary w-full sm:w-auto">
        Fazer meu pré-cadastro
      </a>
      <a href="#como-funciona" className="btn-secondary w-full sm:w-auto">
        Como funciona
      </a>
    </div>
  )
}

export default function Hero() {
  return (
    <section className="relative w-full min-h-[90vh] flex items-center bg-surface-page pt-28 pb-16 md:py-24 overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6 w-full flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-8 z-10">
        <motion.div
          className="w-full lg:w-[42%] flex flex-col items-start text-left gap-5 lg:gap-8 order-1"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.1, delayChildren: 0.2 },
            },
          }}
        >
<motion.div
            className="inline-flex items-center px-4 py-1.5 rounded-full border border-accent-primary/30 bg-accent-primary/5 text-accent-primary text-xs font-semibold tracking-widest uppercase"
            variants={itemVariant}
          >
            Para médicos, por advogados especialistas
          </motion.div>

          <motion.h1
            className="text-[38px] sm:text-[48px] md:text-[64px] lg:text-[72px] font-extrabold tracking-tight leading-[1.05] text-text-primary"
            variants={itemVariant}
          >
            A proteção jurídica que a faculdade{' '}
            <span className="text-accent-primary">não te deu.</span>
          </motion.h1>

          <motion.p
            className="text-base md:text-[20px] text-text-secondary leading-relaxed max-w-lg"
            variants={itemVariant}
          >
            A única plataforma que traduz o direito para a linguagem clínica. Defesa médica preventiva feita por quem entende sua rotina real.
          </motion.p>

          <motion.div variants={ctaVariant} className="hidden lg:block pt-4">
            <CTAButtons />
          </motion.div>
        </motion.div>

        <motion.div
          className="w-full lg:w-[58%] flex items-center justify-center order-2"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.3 }}
        >
          <img
            src={personHero}
            alt="Médico protegido juridicamente"
            className="w-full max-w-[400px] sm:max-w-[500px] md:max-w-[600px] lg:max-w-none h-auto object-contain"
          />
        </motion.div>

        <motion.div
          className="w-full lg:hidden order-3"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.4 }}
        >
          <CTAButtons />
        </motion.div>
      </div>
    </section>
  )
}
